"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var badge_1 = require("./badge");
var discount_1 = require("./discount");
var offers = {
    OFFERS: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    fragment Offers on Offers {\n      badge {\n        ...Badge\n      }\n      discounts {\n        ...Discount\n      }\n    }\n  "], ["\n    ", "\n    ", "\n    fragment Offers on Offers {\n      badge {\n        ...Badge\n      }\n      discounts {\n        ...Discount\n      }\n    }\n  "])), badge_1.default.BADGE, discount_1.default.DISCOUNT),
};
exports.default = offers;
var templateObject_1;
